// extracted by mini-css-extract-plugin
export default {"Box":"StepperBox_Box__hvITw","Title":"StepperBox_Title__RLh9B","Content":"StepperBox_Content__QBw7l"};